module.exports = __webpack_public_path__ + "static/img/default_image_02@2x.f8bd768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/default_image_02@2x.png
// module id = aVgn
// module chunks = 1